import { upperFirst } from 'lodash';
import { rgba } from 'polished';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { colors } from 'styles/shared';

const PlanContainer = styled.div`
  width: 44.6rem;
  height: 9rem;
  background: ${props => rgba(props.background, 0.6)};
  border-radius: 3rem;
  padding: 2.5rem 2.6rem 0 3.2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  border: ${props => (props.active ? `0.2rem solid ${props.color}` : '0.2rem solid transparent')};
`;

const PlanRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 3rem;
  line-height: 3.6rem;
  color: ${props => props.color};
`;

PlanItem.propTypes = {
  plan: PropTypes.object.isRequired,
  activePlan: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired
};

function PlanItem({ plan, activePlan, onSelect }) {
  function selectPlan() {
    onSelect(plan.id);
  }

  function planColor() {
    let color = {background: colors.blue_light, color: colors.blue_dark};
    let level = 0;
    for (const trip of plan.trips) {
      if (trip.risk_level > level) {
        level = trip.risk_level;
      }
    }

    switch (level) {
      case 0:
        color = {background: colors.green_light, color: colors.green_dark};
        break;
      case 1:
        color = {background: colors.green_light, color: colors.green_dark};
        break;
      case 2:
        color = {background: colors.yellow_light, color: colors.yellow_dark};
      break;
      case 3:
        color = {background: colors.yellow_light, color: colors.yellow_dark};
      break;
      case 4:
        color = {background: colors.purple_light, color: colors.purple_dark};
      break;
      case 5:
        color = {background: colors.purple_light, color: colors.purple_dark};
        break;
      default:
        color = {background: colors.green_light, color: colors.green_dark};
        break;
    }
    return color;
  }

  function render() {
    const color = planColor();
    let isActivePlan = activePlan && plan ? plan.id === activePlan.id : false;

    return (
      <PlanContainer background={color.background} color={color.color} active={isActivePlan} onClick={selectPlan}>
        <PlanRow>
          <Title color={color}>{upperFirst(plan.name)}: {plan.trips.length} stops</Title>
        </PlanRow>
      </PlanContainer>
    );
  }

  return render();
}

export default PlanItem;
